<template>
<div v-if="!this.$store.state.general.user.verified">
    <plans msgtitle="You currently do not have access to Segmentation"
            msgdescription="Please choose a plan to pay to enjoy the Segmentation feature"
      ></plans>
  </div>
  <div v-else>

  
  <b-card no-body class="mb-0">
    <!--<b-row class="p-2 pt-3 pb-3">
      <b-col cols :md=3>
        <h5>Step 1: Select data type</h5>
        <b-form-radio-group
          id="btn-radios-2"
          v-model="dataType"
          :options="dataTypeOptions"
          buttons
          button-variant="outline-primary"
          size="md"
          name="radio-btn-outline"
        ></b-form-radio-group>
      </b-col>
      <b-col v-if="dataType == 'database'" cols :md=4>
        <h5>Step 2: Select database</h5>
        <b-form-select
          v-model="database_"
          :options="databases"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
        </b-form-select>
      </b-col>
      <b-col v-if="dataType == 'database' && database_ != null" cols :md=5>
        <h5>Step 3: Select table to view segments</h5>
        <b-form-select
          v-model="collection_"
          :options="collections"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
        </b-form-select>
      </b-col>
      <b-col v-if="dataType == 'file'" cols :md=6>
        <h5>Step 2: Select file to view segments</h5>
        <b-form-select
          v-model="file_"
          :options="uploaded_files"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
        </b-form-select>
      </b-col>
    </b-row> -->

    <b-row class="p-2 pt-3 pb-3">
      <b-col cols :md=6>
        <h5>1. Select Project</h5>
        <b-form-select
          v-model="projectID"
          :options="projects"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
        </b-form-select>
      </b-col>
      <b-col v-if="project_ != null" cols :md=6>
        <h5>2. Select File Type</h5>
        <b-form-select
          v-model="meta_"
          :options="metas"
          value-field="value"
          text-field="text"
          disabled-field="notEnabled"
          style="max-width: 300px;"
          size="lg"
          >
        </b-form-select>
      </b-col>
    </b-row>

    <!-- <b-tabs v-if="raw_file != null && dataType == 'database'" card nav-class="pt-3 pl-2" class="tabs" 
      v-model="tab" :key="collection_">
      <template v-slot:title>
        <div class="text-center px-3">
          <div class="h4 m-0 p-0">
            <count-to :start-val="0" :end-val="filteredSegmentList(raw_file).length" :duration="2000"/>
          </div>
          <div>{{ remove_underscore(raw_file['id']) }}</div>
        </div>
      </template>
        <b-button size="lg" variant="primary" class="mt-3 ml-2"  
          @click="initEditSession(null, raw_file['originalName'], raw_file['database'], dataType, file=raw_file['_id'])">
          <i class="fa fa-plus mr-2"/>
            Add new segment
        </b-button>
      <b-card-group columns class="mt-3 pl-2">
        <segment-summary
          v-for="segment in filteredSegmentList(raw_file)"
          v-bind="segment"
          :key="changeStamps[segment.id] || segment.id"
          :cloning="cloningSegmentIDList.includes(segment.id)"
          @view="() => onView(segment.id)"
          @list="() => onListView(segment.id)"
          @clone="() => onClone(segment.id)"
          @edit="() => initEditSession(segment.id, raw_file['originalName'], raw_file['database'], dataType, file=raw_file['_id'])"
          @delete="() => onDelete(segment.id)"/>
      </b-card-group>

      <div v-if="editingSessionID">
        <segment-editor
        
          :key="editingSessionID"
          :collection_name="collection_"
          :database_name="database_"
          :data_type="dataType"
          :file="raw_file['_id']"
          :id="editingSegmentID"
          @close="onEndEditSession"/>
      </div>
    </b-tabs> -->

    <b-tabs v-if="raw_file != null" card nav-class="pt-3 pl-2" class="tabs" 
      v-model="tab" :key="file_">
      <template v-slot:title>
        <div class="text-center px-3">
          <div class="h4 m-0 p-0">
            <count-to :start-val="0" :end-val="filteredSegmentList(raw_file).length" :duration="2000"/>
          </div>
          <div>{{ remove_underscore(raw_file['id']) }}</div>
        </div>
      </template>
        <b-button size="lg" variant="primary" class="mt-3 ml-2"  
          @click="initEditSession(null, raw_file['originalName'], raw_file['database'], dataType, file=raw_file['_id'])">
          <i class="fa fa-plus mr-2"/>
            Add new segment
        </b-button>
      <b-card-group columns class="mt-3 pl-2">
        <segment-summary
          v-for="segment in filteredSegmentList(raw_file)"
          v-bind="segment"
          :key="changeStamps[segment.id] || segment.id"
          :cloning="cloningSegmentIDList.includes(segment.id)"
          :collection_name="collection_"
          :database_name="database_"
          :id="segment.id"
          @view="() => onView(segment.id)"
          @list="() => onListView(segment.id)"
          @clone="() => onClone(segment.id)"
          @edit="() => initEditSession(segment.id, raw_file['originalName'], raw_file['database'], dataType, file=raw_file['_id'])"
          @delete="() => onDelete(segment.id)"/>
      </b-card-group>

      <div v-if="editingSessionID">
        <segment-editor
        
          :key="editingSessionID"
          :collection_name="collection_"
          :database_name="database_"
          :data_type="dataType"
          :file="raw_file['_id']"
          :id="editingSegmentID"
          @close="onEndEditSession"/>
      </div>
    </b-tabs>
  </b-card>
  </div>
</template>

<script>
  import SegmentEditor from './Editor';
  import Plans from '../Plans/Plans'
  import SegmentSummary from './Summary';
  import {deleteSegment, SEGMENT_UPDATE} from '../../store/segments';
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;

  export default {
    name: 'SegmentDashboard',
    components: {SegmentSummary, SegmentEditor, Plans},

    data() {
      const C = this.$store.state.files.collections;
      const F = this.$store.state.files.fileList;
      const PL = this.$store.state.files.projectList;
      const user = this.$store.state.user;

      return {
        tab: 0,
        editingSegmentID: null,
        editingSessionID: null,
        F: F,
        C: C,
        PL: PL,
        database_: "sfl_app_5_data", // F[0].database,
        projectID: null,
        project_: null,
        cloningSegmentIDList: [],
        changeStamps: {},
        raw_file: null,
        file_: null,
        collection_: null,
        meta_: null,
        database_: null,
        dataType: 'database',
        dataTypeOptions: [
          {text: 'Database', value: 'database'},
          {text: 'File', value: 'file'}
        ]
      };
    },

   

    computed: {
      collections() {
        //  return this.$store.state.files.collections;
        var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.originalName && file.database === this.database_ && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },
      
      uploaded_files() {
        //  return this.$store.state.files.collections;
        var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          if (file.database === 'sfl_app_5_data' && !!file.originalName && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },

      databases() {
        var databases = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.database && !databases.includes(file.database)) {
            databases.push(file.database);
          }
        });
        return databases;
      },
    
      raw_files() {
        console.log("files: ", this.F);
        return this.F;
      },

      metas() {
        var metas = [];
        var projectMetas = [];
        if (!!this.project_ && !!this.project_.files && Object.keys(this.project_.files).length > 0) {
          projectMetas = Object.keys(this.project_.files);
        }
        this.$store.state.general.metas.forEach(meta => {
          if (projectMetas.length === 0) {
            metas.push({'value': meta.type, 'text': meta.name});
          } else {
            if (projectMetas.indexOf(meta.type) > -1) {
              metas.push({'value': meta.type, 'text': meta.name});
            }
          }
        });
        return metas;
      },

      projects(){
        //  return this.$store.state.files.collections;
        var projects = [];
        this.$store.state.files.projectList.forEach(project => {
          var p = {'value': project.id, 'text': project.name};
          if (!projects.includes(p)) {
            projects.push(p);
          }
        });
        return projects;
      },

      projectFiles() {
        let rawFiles = this.getFormattedFiles();
        let files = [];
        for (const [key, value] of Object.entries(this.project_.files)) {
          files.push({'type': key, 'file': rawFiles[value]['originalName']});
        }
        return files;
      }
    },

    watch: {
      collection_: function(val) {
        if (!!val) {
          this.F.forEach(file => {
          if (!!file.originalName && file.database === this.database_ && file.originalName === this.collection_) {
            this.raw_file = file;
          }
        });
        }
      },
      
      file_: function(val) {
        if (!!val) {
          this.raw_files.forEach(file => {
            console.log("Checker: ", file.database, this.database_, file.originalName, this.file_);
          if (!!file.originalName && file.originalName === this.file_) {
            this.raw_file = file;
          }
        });
        }
      },

      projectID: function(val) {
        if (!!val) {
          this.raw_file = null;
          this.project_ = this.getSelectedProject();
        }
      },
      
      meta_: function(val) {
        if (!!val) {
          var fileID = this.project_.files[val];
          this.$store.state.files.fileList.forEach(file => {
          // var col_name = this.getCollection(file);
          if (file.id === fileID) {
              this.raw_file = file;
              this.collection_ = file;
            }
          });
        }
      }
    },

    methods: {
      initEditSession(id = null, coll=null, database=null, data_type=null, file=null) {
        this.editingSegmentID = id;
        this.editingSessionID = (new Date()).getMilliseconds();
        this.collection_ = coll;
        this.database_ = database;
        this.file = file;
        this.dataType = data_type;
      },

      filteredSegmentList(x){
        return this.$store.state.segments.segmentList.filter(y => y.collection === x['_id'] && y.database === x['database'] );
      },

      getSelectedProject() {
        var project = null;
        this.$store.state.files.projectList.forEach(p => {
          if (p.id === this.projectID) {
            project = p;
          }
        });
        return project;
      },

      remove_underscore(x){
          return x.replace("_", " ").toUpperCase();
      },

      onEndEditSession(changed) {
        if (changed && this.editingSegmentID) {
          this.changeStamps = {
            ...this.changeStamps,
            [this.editingSegmentID]: (new Date()).getMilliseconds()
          };
        }
        this.editingSessionID = null;
      },

      onClone(id) {
        this.cloningSegmentIDList = [...this.cloningSegmentIDList, id];
        axios.post(fullURL(`/segment/${id}`))
          .then(({data: segment}) => {
            this.$store.commit(SEGMENT_UPDATE, {segment});
            this.initEditSession(segment.id, null, null);
          })
          .catch(console.log)
          .finally(() => {
            this.cloningSegmentIDList = this.cloningSegmentIDList.filter(i => i !== id);
          });
      },

      onDelete(id) {
        this.$store.dispatch(deleteSegment(id))
          .catch(console.log);
      },

      onView(id) {
        this.$router.push(`/segments/${this.projectID}/${this.meta_}/${id}?view=insights`);
      },

      onListView(id) {
        this.$router.push(`/dashboard/${id}?view=list`);
      }
    }
  };
</script>
